///<reference path="../../types/adonisjs__websocket-client.d.ts" />
import type { Connection } from '@adonisjs/websocket-client'

import { useEffect, useState, useRef } from 'react'
import Ws from '@adonisjs/websocket-client'

export function useAppWebsocket (wsServerUrl: string) {
  const websocket = useRef<Connection | null>(null)
  const [ ready, setReady ] = useState(false)

  useEffect(() => {
    if (!websocket.current) {
      const socket = Ws(wsServerUrl).connect()

      socket.on('open', () => {
        setReady(true)
      })
      socket.on('close', () => {
        setReady(false)
      })

      websocket.current = socket
    }

    return () => {
      if (websocket.current) {
        websocket.current.close()
        websocket.current = null
      }

      setReady(false)
    }
  }, [ wsServerUrl ])

  return {
    socket: websocket.current,
    ready: ready
  }
}
